class Loader {

    defaultOptions(){
        return {
            'onlyIcon': false,
        };
    }

    constructor(options){
        this.settings = $.extend(this.defaultOptions(),options);
        // initalize object
        this.initialize();
    }

    render(){
        return this.$content;
    }

    initialize(){


        if(this.settings.onlyIcon){
            this.$content = $('<div/>')
            .addClass('spinner-border')
            .attr('role','status')
            .append(
                $('<span/>')
                .addClass('sr-only')
                .append(window.translate('inProgress')+' ...')
            );
        }else{
            this.$content =  $('<div/>')
            .addClass('d-flex justify-content-center')
            .append(
                $('<div/>')
                .addClass('spinner-border')
                .attr('role','status')
                .append(
                    $('<span/>')
                    .addClass('sr-only')
                    .append(window.translate('inProgress')+' ...')
                )
            );
        }
    }
}

module.exports = Loader;